import React from 'react';
import { Col, Row, Typography } from 'antd';
import Icon from '@ant-design/icons';

import useInit from './hooks/useInit';
import TableCard from 'src/shared/components/table/Table';
import { ButtonField, SelectField } from 'src/shared/components/form';
import { PlusIcon } from 'src/assets/icons';
import ModalForm from './ModalForm';
import { WrapperStyled } from './styled';

const { Title } = Typography;

const Camera: React.FC = () => {
  const {
    columns,
    dataSource,
    totalPageCameras,
    formik,
    isLoading,
    currentPage,
    isShowModal,
    dataEdit,
    dataSelectTerminals,
    terminalId,
    setIsShowModal,
    setDataEdit,
    fetchDataCameras,
    setCurrentPage,
    setTerminalId,
  } = useInit();

  const { getFieldProps, setFieldValue } = formik;

  return (
    <React.Fragment>
      <WrapperStyled className="camera-screen">
        <Col span={20} className="col-form">
          <Row className="row-btn">
            <Col span={8}>
              <Title level={4} className="title color-title-table-light-theme">
                カメラ
              </Title>
            </Col>

            <Col span={16} className="col-left">
              <SelectField
                field={getFieldProps('terminalId')}
                optionsSelect={dataSelectTerminals}
                setFieldValue={setFieldValue}
                onChange={id => {
                  setTerminalId(id);
                  setCurrentPage(1);
                  void fetchDataCameras({ terminalId: id, page: 1 });
                }}
              />
              <ButtonField
                content={<Icon component={PlusIcon} />}
                type="primary"
                className="btn-create"
                onClick={() => {
                  setIsShowModal(true);
                  setDataEdit(null);
                }}
              />
            </Col>
          </Row>

          <Row className="row-table">
            <TableCard
              loading={isLoading}
              columns={columns}
              dataSource={dataSource}
              rowKey="id"
              totalPages={totalPageCameras}
              currentPage={currentPage}
              onChangePage={page => {
                setCurrentPage(page);
                void fetchDataCameras({ page });
              }}
            />
          </Row>
        </Col>
      </WrapperStyled>

      <ModalForm
        terminalSelects={dataSelectTerminals}
        isOpen={isShowModal}
        setIsShowModal={setIsShowModal}
        dataEdit={dataEdit}
        terminalId={terminalId}
        fetchDataCameras={fetchDataCameras}
      />
    </React.Fragment>
  );
};

export default Camera;
